import * as Sentry from '@sentry/browser';

const RAILS_ENV = ['stage', 'production'];
// vite_ruby builds with the Rails environment as the Vite mode.
const currentRailsEnv = import.meta.env.MODE;

class SentryLogger {
    constructor(){
        if(!SentryLogger.instance){
            this.isSentryAvailable = false;
            SentryLogger.instance = this;
        }
        return SentryLogger.instance;
    }

    initializeSentry() {
        if (!this.isSentryAvailable && RAILS_ENV.includes(currentRailsEnv)) {
            this.isSentryAvailable = true;
            Sentry.init({
                dsn: 'https://2eaf9832cf68442f8ca6a83ed619d071@o206482.ingest.sentry.io/5191403',
                environment: currentRailsEnv,
            });
        }
    }
    sendInfoReport(message) {
        if (!this.isSentryAvailable) {
            return;
        }
        Sentry.withScope((scope) => {
            scope.setLevel("info");
            scope.addBreadcrumb({}, 100);
            Sentry.captureMessage(message);
        });
    }

}

export const sentryInstance = new SentryLogger();
